import { FC } from 'react'
import { PageTitle } from './PageTitle'

/** Props for the shared page header block. */
type PageHeaderProps = {
  title: string
  subtitle?: string
}

/**
 * Standard page header with title and optional subtitle.
 * Keeps headings consistent across pages.
 */
export const PageHeader: FC<PageHeaderProps> = ({ title, subtitle }) => {
  return (
    <div>
      <PageTitle>{title}</PageTitle>
      {subtitle && <p className='mt-3 text-brand-smoky/80'>{subtitle}</p>}
    </div>
  )
}
